import { LEAD_TIME, TAG_DATE, TAGGED_BY } from "MODULES/inventories/constants";
import moment from "moment";

export const handleRepairItem = ({
  inventoryDetails,
  change,
  getNameFromSection
}) => {
  if (inventoryDetails.repairing) {
    const leadTime =
      inventoryDetails.repair_and_hold_lead_time ||
      inventoryDetails.repair_estimated_lead_time;

    change(
      getNameFromSection(TAGGED_BY),
      inventoryDetails.most_recent_repair_order.company.name
    );
    change(getNameFromSection(LEAD_TIME), leadTime);

    if (inventoryDetails.repairing && !inventoryDetails.tag_date) {
      const today = moment()
        .add(leadTime, "days")
        .format("YYYY-MM-DD");
      change(getNameFromSection(TAG_DATE), today);
    } else {
      change(getNameFromSection(TAG_DATE), inventoryDetails.tag_date);
    }
  }
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/helpers.js